import { create } from "@incodetech/welcome";
import { REACT_APP_USER_SERVER_INCODE } from 'constants/general';
const apiURL = REACT_APP_USER_SERVER_INCODE;
// const apiURL = process.env.REACT_APP_USER_SERVER_INCODE;
//const clientId = process.env.REACT_APP_CLIENT_ID_INCODE;

const incode = create({
  //clientId: clientId,
  apiURL: apiURL,
  lang: "es",
  theme: {
    main: "#eb0028",
    mainButton: {
      borderRadius: "10px",
      color: "#ffff",
      border: "#eb0028",
    },
  },
});
export default incode;